@if (conceptForm.configuredVisibility) {
  <div class="concept-form__form-poll-landing-container">
    @if (!conceptForm.startedPoll) {
      <div class="concept-form__container-init-poll">
        @if (conceptForm.concept.description) {
          <div class="concept-form__container-description-poll">
            <div class="common-text-field__text-value-sequential"
              [innerHTML]="conceptForm.concept.description"></div>
          </div>
        }
        <img class="concept-form__img-init-poll"
          src="../assets/img/init-poll.png"
          alt="imagen de inicio de la encuesta"/>
      </div>
      <div class="concept-form__footer-buttons">
        <button type="button" class="common-button__text"
          (click)="startPoll()">
          <span class="common-button__text-title"
            [afTranslate]="'common.start'">
            Comenzar
          </span>
        </button>
      </div>
    }@else {
      <div class="common-progress-indicator__bar-block landing-page__mobile h-[8px]">
        <div class="common-progress-indicator__bar-inner"
          [ngStyle]="{width: (conceptForm.fieldSelected?.countFieldVisible/conceptForm.sequentialFieldsVisibility?.length)*100+'%'}"
          role="progressbar"
          aria-label="Progreso de la encuesta"
          aria-valuemin="0%"
          aria-valuemax="100%"
          [attr.aria-valuenow]="(conceptForm.fieldSelected?.countFieldVisible/conceptForm.sequentialFieldsVisibility?.length)*100+'%'"
          [attr.aria-valuetext]="(conceptForm.fieldSelected?.countFieldVisible/conceptForm.sequentialFieldsVisibility?.length)*100+'%' + conceptForm.fieldSelected?.countFieldVisible + ' de 100%'"></div>
      </div>
      <div class="common-progress-indicator__container-fragment-progress landing-page__desktop-tablet">
        @for (stepField of conceptForm.sequentialFieldsVisibility; track $index) {
          <div [ngClass]="stepField.countFieldVisible < conceptForm.fieldSelected.countFieldVisible?'common-progress-indicator__fragment-progress-completed':'common-progress-indicator__fragment-progress'">
            @if (stepField.countFieldVisible === conceptForm.fieldSelected.countFieldVisible) {
              <div class="common-progress-indicator__fragment-progress-active"></div>
            }
          </div>
        }
      </div>
      <div class="concept-form__container-form-poll">
        <div class="concept-form__container-inner-form-poll">
          <div class="concept-form__container-titles-poll">
            <div class="common-section-title__gs-container-primary">
              <div class="common-section-title__gs-item-container">
                @if (conceptForm.fieldSelected?.isHighlightGroup) {
                  <i aria-hidden="true" class="lf-icon-important common-icon__md common-section-title__gs-icon-important"></i>
                }
                <span class="common-section-title__gs-label-text">
                  {{conceptForm.fieldSelected?.nameGroup}}
                </span>
              </div>
            </div>
            @if(conceptForm.fieldSelected?.nameSubgroup){
              <div class="common-section-title__gs-container-secondary-sequential">
                @if (conceptForm.fieldSelected?.isHighlightSubgroup) {
                  <i aria-hidden="true" class="lf-icon-important common-icon__md common-section-title__gs-icon-important"></i>
                }
                <div class="common-section-title__gs-item-container-sequential">
                  <span class="common-section-title__gs-label-sequential-text">
                    {{conceptForm.fieldSelected?.nameSubgroup}}
                  </span>
                </div>
              </div>
            }
          </div>
          <div class="concept-form__container-field-sequential">
            <field-item
              [fieldInfo]="conceptForm.fieldSelected"
              [evaluatedConcepts]="conceptForm.concept.evaluatedFields"
              (evaluatedConceptChange)="changesInEvaluatedConcept($event)"
              (changeConceptFromField)="changeConceptFromField($event.template)"
              [public]="conceptForm.public"
              [concept]="conceptForm.concept"
              [evaluationId]="conceptForm.evaluationId"
              [conceptLocked]="conceptForm.conceptLocked">
            </field-item>
          </div>
        </div>
      </div>
      <div class="concept-form__footer-buttons">
        @if (conceptForm.fieldSelected?.countFieldVisible > 1) {
          <button type="button" class="common-button__text-border"
            (click)="previousQuestionPoll()">
            <span class="common-button__text-title"
              [afTranslate]="'common.previous'">Anterior</span>
          </button>
        }
        <button type="button" class="common-button__text"
          [disabled]="conceptForm.viewEditConcept"
          (click)="nextOrSavePoll()">
          <span class="common-button__text-title"
            [afTranslate]="conceptForm.fieldSelected?.lastField?'common.send':'common.next'">
            Enviar/Siguiente
          </span>
        </button>
      </div>
    }
  </div>
}
